<template>

  <div class="stages-page">
    <Header></Header>
    <section class="stages-section">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-4" style="padding-left: 0;">
            <h2><span style="text-transform: capitalize;">{{$route.params.id}}<span v-if="$route.params.id != 'Other'"> Stages</span></span></h2>
          </div>
          <div class="col-md-8" style="padding-right: 0;">
            <StageFilter />
          </div>
        </div>
      </div>
    </section>
    <section class="stg-section">
      <div class="container">
        <div class="row row-2">
          <router-link v-if="!loading" class="col-md-6 fc-col background-fit" :to="`/stage/` + list._id + `/`" v-for="(list) in lists" v-bind:key="list.id" :style="{ backgroundImage: `url(${imageUrl + list.videoId[0].videoImageFile})` }">
            <div class="inner-blk">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.userId[0].profiles[0].images[0].profileImageFile})` }"></div>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>
                </div>
              </div>
            </div>
          </router-link>
          <Loader v-if="loading" />
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import Loader from './include/Loader'
import StageFilter from './include/StageFilter'
import axios from 'axios'
import router from '../router'
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
export default {
  name: 'Stages',
  components: {
    'Header': Header,
    'Footer': Footer,
    'Loader': Loader,
    'StageFilter': StageFilter
  },
  mounted () {
      axios
          .get('/stagesByTag', {
              params: {
                  tag: this.routeId
              }
          })
          .then(response => {
              this.loading = false
              this.lists = response.data
          })
          .catch(error => console.log(error))
  },
  methods: {
    tagFuntion: function(event) {
        console.log(this.routeId)
    }
  },
  data () {
      return {
          backgroundUrl: backgroundUrl,
          backgroundUrl1: backgroundUrl1,
          backgroundUrl2: backgroundUrl2,
          backgroundUrl4: backgroundUrl4,
          backgroundUrl5: backgroundUrl5,
          imageUrl: process.env.imageUrl,
          routeId: router.history.current.params.id,
          msg: 'Welcome to Your Vue.js App',
          lists: '',
          loading: true
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StagesTags.vue